require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-archive-people-scott-marlow.json") })
        }
      }, "path---people-archive-people-scott-marlow");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-archive-people-scott-marlow!./.cache/json/people-archive-people-scott-marlow.json
// module id = 1449
// module chunks = 231608221292675